/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { Button, InfomindsColors, Language, useLanguage, useTheme } from '@infominds/react-native-components'
import { useAuthentication } from '@infominds/react-native-license'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { useFocusEffect } from '@react-navigation/core'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Alert, Platform, ScrollView, StyleSheet, Switch } from 'react-native'
import DeviceInfo from 'react-native-device-info'
import RNPickerSelect from 'react-native-picker-select'

import api from '../apis/Api'
import { Text, TextInput, View } from '../components/Themed'
import Colors from '../constants/Colors'
import useEnableBottomNavigation from '../hooks/useEnableBottomNavigation'
import useSettings from '../hooks/useSettings'

export default function SettingsScreen() {
  useEnableBottomNavigation()

  const { historyDays, setHistoryDays } = useSettings()

  const { colorScheme, updateColorScheme } = useTheme()
  const { i18n, language, setLanguageAsync } = useLanguage()
  const { license, token, url, name, company, logout, updateToken } = useAuthentication()

  const previousMandant = useRef(company)

  const [wait, setWait] = useState(false)
  const [selectedMandant, setSelectedMandant] = useState(company)
  const [mandants, setMandants] = useState([])

  useFocusEffect(
    useCallback(() => {
      url &&
        token &&
        api
          .getMandants(token, url)
          .then((resultMandant: any) => {
            setMandants(resultMandant)
          })
          .catch(console.error)
    }, [token, url])
  )

  useEffect(() => {
    AsyncStorage.getItem('wait')
      .then(res => {
        if (res) setWait(JSON.parse(res))
      })
      .catch(console.error)
  }, [])

  const toggleSwitch = () => {
    updateColorScheme(colorScheme === 'light' ? 'dark' : 'light')
  }

  const toggleWaitSwitch = () =>
    setWait(previousState => {
      AsyncStorage.setItem('wait', String(!previousState)).catch(console.error)

      return !previousState
    })

  const handleLogout = () => {
    if (Platform.OS === 'web') {
      // eslint-disable-next-line no-alert
      const result = window.confirm(['Logout', i18n.t('LOGOUT_MESSAGE')].filter(Boolean).join('\n'))

      if (result) {
        logout().catch(err => console.error('Logout error', err))
      }
    } else {
      Alert.alert('Logout', i18n.t('LOGOUT_MESSAGE'), [
        {
          text: i18n.t('CANCEL'),
          style: 'cancel',
        },
        {
          text: i18n.t('ID_LOGOUT'),
          style: 'destructive',
          onPress: () => {
            logout().catch(err => console.error('Logout error', err))
          },
        },
      ])
    }
  }

  const pickerLanguage = (
    <RNPickerSelect
      onValueChange={(value: Language) => {
        setLanguageAsync(value)
      }}
      value={language}
      style={{
        inputIOS: { color: Colors[colorScheme].text },
        inputAndroid: { color: Colors[colorScheme].text, height: 40 },
        inputAndroidContainer: { alignSelf: 'flex-end' },
        inputIOSContainer: { alignSelf: 'flex-end', padding: 10, height: 40 },
      }}
      items={[
        { label: 'Deutsch', value: 'de' },
        { label: 'Italiano', value: 'it' },
        { label: 'English', value: 'en' },
      ]}
    />
  )

  const PickerMandats = () => (
    <RNPickerSelect
      onValueChange={value => {
        if (value !== -1 && value != null && value !== company) {
          const newValue = value.toString()
          setSelectedMandant(newValue)
          updateToken(newValue, undefined)
            .then(() => {
              previousMandant.current = newValue
            })
            .catch(err => {
              setSelectedMandant(previousMandant.current)
              console.error('Failed company re-auth:', err)
            })
        }
      }}
      value={selectedMandant}
      style={{
        inputIOS: { color: Colors[colorScheme].text },
        inputAndroid: { color: Colors[colorScheme].text, height: 40 },
        inputAndroidContainer: { alignSelf: 'flex-end' },
        inputIOSContainer: { alignSelf: 'flex-end', padding: 10, height: 40 },
      }}
      items={mandants.map((item: any) => {
        return { label: item.description, value: item.id }
      })}
    />
  )

  const Settings = ({ title, content }: any) => (
    <View
      style={[styles.settingsItem, { borderTopColor: Colors[colorScheme].listItemBackground }]}
      lightColor={Colors.light.background}
      darkColor={Colors.dark.background}>
      <Text
        style={{
          color: Colors[colorScheme].text,
          textAlignVertical: 'center',
          width: '50%',
        }}
        lightColor={Colors.light.text}
        darkColor={Colors.dark.text}>
        {title}
      </Text>
      <View>{content}</View>
    </View>
  )

  return (
    <View style={styles.container} lightColor={Colors.light.background} darkColor={Colors.dark.background}>
      <ScrollView style={{ flex: 1 }}>
        <View style={styles.settings} lightColor={Colors.light.background} darkColor={Colors.dark.background}>
          <View
            style={[styles.settingsItem, { borderTopWidth: 0, marginTop: 0 }]}
            lightColor={Colors.light.background}
            darkColor={Colors.dark.background}>
            <Text
              style={{
                color: Colors[colorScheme].text,
                textAlignVertical: 'center',
                width: '50%',
              }}
              lightColor={Colors.light.text}
              darkColor={Colors.dark.text}>
              {i18n.t('ID_DARK_MODE')}
            </Text>
            <View>
              <Switch
                trackColor={{ false: '#767577', true: '#767577' }}
                thumbColor={colorScheme === 'dark' ? Colors.tint : '#f4f3f4'}
                ios_backgroundColor="#3e3e3e"
                onValueChange={toggleSwitch}
                value={colorScheme === 'dark'}
                style={{ alignSelf: 'flex-end' }}
              />
            </View>
          </View>

          {Platform.OS !== 'android' ? (
            <Settings title={i18n.t('ID_SPRACHE')} content={<>{pickerLanguage}</>} />
          ) : (
            <View
              style={{
                borderTopWidth: 1,
                borderTopColor: Colors[colorScheme].listItemBackground,
                marginTop: 10,
              }}>
              <Text style={{ alignSelf: 'flex-start' }}>{i18n.t('ID_SPRACHE')}</Text>
              {pickerLanguage}
              <View style={styles.separator} />
            </View>
          )}

          {Platform.OS !== 'android' ? (
            <Settings title={i18n.t('ID_MANDANTS')} content={<PickerMandats />} />
          ) : (
            <View
              style={{
                borderTopWidth: 1,
                borderTopColor: Colors[colorScheme].listItemBackground,
                marginTop: 10,
              }}>
              <Text style={{ alignSelf: 'flex-start' }}>{i18n.t('ID_MANDANTS')}</Text>
              <PickerMandats />
              <View style={styles.separator} />
            </View>
          )}

          <View
            style={[styles.settingsItem, { borderTopColor: Colors[colorScheme].listItemBackground }]}
            lightColor={Colors.light.background}
            darkColor={Colors.dark.background}>
            <Text
              style={{
                color: Colors[colorScheme].text,
                textAlignVertical: 'center',
                width: '50%',
              }}
              lightColor={Colors.light.text}
              darkColor={Colors.dark.text}>
              {i18n.t('ID_HISTORYDAYS')}
            </Text>
            <TextInput
              lightColor={Colors.light.listItemBackground}
              darkColor={Colors.dark.listItemBackground}
              style={[styles.input, { color: Colors[colorScheme].text }]}
              onChangeText={text => {
                setHistoryDays(Number(text))
              }}
              keyboardType="number-pad"
              value={historyDays.toString()}
            />
          </View>

          <Settings
            title={'Always wait for result (~30s)'}
            content={
              <Switch
                trackColor={{ false: '#767577', true: '#767577' }}
                thumbColor={wait ? Colors.tint : '#f4f3f4'}
                ios_backgroundColor="#3e3e3e"
                onValueChange={toggleWaitSwitch}
                value={wait}
                style={{ alignSelf: 'flex-end' }}
              />
            }
          />

          {name && (
            <Settings
              title={i18n.t('ID_USERNAME')}
              content={
                <Text
                  style={{
                    color: Colors[colorScheme].text,
                    alignSelf: 'flex-end',
                  }}
                  lightColor={Colors.light.text}
                  darkColor={Colors.dark.text}>
                  {name}
                </Text>
              }
            />
          )}

          <Settings
            title={i18n.t('SETTINGS_LICENSE')}
            content={
              <Text
                style={{
                  color: Colors[colorScheme].text,
                  alignSelf: 'flex-end',
                }}
                lightColor={Colors.light.text}
                darkColor={Colors.dark.text}>
                {license}
              </Text>
            }
          />

          <Settings
            title="Server"
            content={
              <Text
                style={{
                  color: Colors[colorScheme].text,
                  alignSelf: 'flex-end',
                }}
                lightColor={Colors.light.text}
                darkColor={Colors.dark.text}>
                {url}
              </Text>
            }
          />

          <Settings
            title={i18n.t('ID_APP_VERSION')}
            content={
              <Text
                style={{
                  color: Colors[colorScheme].text,
                  alignSelf: 'flex-end',
                }}
                lightColor={Colors.light.text}
                darkColor={Colors.dark.text}>
                {Platform.OS === 'web' ? process.env.VERSION : DeviceInfo.getVersion()}
                {(Platform.OS === 'android' || Platform.OS === 'ios') && ` (${DeviceInfo.getBuildNumber()})`}
              </Text>
            }
          />
          <Button title="Logout" style={{ backgroundColor: InfomindsColors.red, padding: 8, margin: 0, marginTop: 12 }} onPress={handleLogout} />
        </View>
      </ScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  settingsItem: {
    marginTop: 15,
    paddingTop: 5,
    borderTopWidth: 1,
  },
  settings: {
    padding: 10,
  },
  input: {
    marginBottom: 10,
    padding: 5,
    width: '20%',
    borderWidth: 0,
    borderRadius: 5,
    color: '#ffffff',
    alignSelf: 'flex-end',
  },
  separator: {
    borderBottomWidth: 1,
    // borderBottomColor: Colors.,
  },
})
